String.prototype.toCamelCase = function toCamelCase() {
  return this.valueOf()
    .replace(/\s(.)/g, ($1) => $1.toUpperCase())
    .replace(/\s/g, '')
    .replace(/^(.)/, ($1) => $1.toLowerCase());
};
